import request from '@/utils/request'

const url = 'admin/baseset.animal_type'
/**
 * 活畜品种接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加AnimalVariety
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑AnimalVariety
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情AnimalVariety
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 删除AnimalVariety
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  }

}

export default api
